export default function normalizeText<V extends string | null>(value: V): V {
  if (typeof value !== 'string') {
    return value
  }

  return value
    .replace(/\s/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim() as V
}
